import { render, staticRenderFns } from "./GpPrompt.vue?vue&type=template&id=5dfbdcaa"
import script from "./GpPrompt.vue?vue&type=script&lang=js"
export * from "./GpPrompt.vue?vue&type=script&lang=js"
import style0 from "./GpPrompt.vue?vue&type=style&index=0&id=5dfbdcaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports